var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import Editor from "react-simple-wysiwyg";
var EditableMom = function (props) {
    var _a = __read(useState(props === null || props === void 0 ? void 0 : props.editableMomText), 2), emailText = _a[0], setEmailText = _a[1];
    var _b = __read(useState(false), 2), textLimitError = _b[0], setTextLimitError = _b[1];
    var handleSubmit = function () {
        var parser = new DOMParser();
        var doc = parser.parseFromString(emailText, "text/html");
        var editableElements = doc.querySelector(".editable");
        var paragraphs = editableElements.querySelectorAll("p");
        if ((paragraphs === null || paragraphs === void 0 ? void 0 : paragraphs.length) > 0) {
            paragraphs.forEach(function (p) {
                if (p.classList.contains("noneditable")) {
                    p.remove();
                }
            });
            paragraphs = editableElements.querySelectorAll("p");
            var cleanedHTML = Array.from(paragraphs)
                .map(function (p) { return p.innerHTML.trim(); })
                .join("");
            var cleanText = cleanedHTML === null || cleanedHTML === void 0 ? void 0 : cleanedHTML.replace(/&nbsp;/g, " ").replace(/^\s+/, "");
            if ((cleanText === null || cleanText === void 0 ? void 0 : cleanText.length) < 50) {
                setTextLimitError(true);
                return;
            }
        }
        else {
            var tableRow = editableElements.querySelectorAll("td");
            var cleanedHTML = Array.from(tableRow)
                .map(function (td) { return td.innerHTML.trim(); })
                .join("");
            var cleanText = cleanedHTML === null || cleanedHTML === void 0 ? void 0 : cleanedHTML.replace(/&nbsp;/g, " ").replace(/<br\s*\/?>/g, "").replace(/^\s+/, "");
            if ((cleanText === null || cleanText === void 0 ? void 0 : cleanText.length) < 50) {
                setTextLimitError(true);
                return;
            }
        }
        document.querySelectorAll(".rsw-ce .editable").forEach(function (el) {
            el.removeAttribute("contenteditable");
        });
        props === null || props === void 0 ? void 0 : props.setEditableMomText(emailText);
        props === null || props === void 0 ? void 0 : props.setShowEditableMom(false);
        props === null || props === void 0 ? void 0 : props.setIsMoMEdited(true);
    };
    useEffect(function () {
        document.querySelectorAll(".rsw-ce .editable").forEach(function (el) {
            if (el.getAttribute("contenteditable") !== "true") {
                el.setAttribute("contenteditable", "true");
            }
            el.addEventListener("input", function () {
                if (el.innerHTML.trim() === "") {
                    el.innerHTML = "<td><br></td>";
                    var range = document.createRange();
                    var selection = window.getSelection();
                    range.selectNodeContents(el.querySelector("td"));
                    range.collapse(false);
                    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
                    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
                }
            });
            el.addEventListener("keydown", function (e) {
                var _a;
                var td = el.querySelector("td");
                if (!td || !td.contains((_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.anchorNode)) {
                    e.preventDefault();
                }
            });
        });
    }, [emailText]);
    return (React.createElement("div", { className: "d-flex flex-column justify-content-center gap-3" },
        React.createElement("div", { className: "DMSansBold_20_700 d-flex justify-content-center" }, "Edit Mom"),
        React.createElement("div", null,
            React.createElement(Editor, { value: emailText, onChange: function (e) {
                    setTextLimitError(false);
                    setEmailText(e.target.value);
                }, disabled: true }),
            textLimitError && (React.createElement("div", { className: "DMSanN_14_400 txt_bloodRed mt-1 text-center" }, "Please enter minimum 50 characters."))),
        React.createElement("div", { className: "d-flex justify-content-center gap-3 align-items-center my-3" },
            React.createElement("span", { className: "txt-hanBlue DMSans_13_400 hand_cursor", onClick: function () {
                    var _a;
                    setTextLimitError(false);
                    setEmailText((_a = props === null || props === void 0 ? void 0 : props.emailTemplateResp) === null || _a === void 0 ? void 0 : _a.momResult);
                } }, "Discard Changes"),
            React.createElement("span", { className: "DMSansMedium_16_500 bg-tomato save-mom hand_cursor", onClick: function () {
                    handleSubmit();
                } }, "Save MoM"))));
};
export default EditableMom;
